const EditIcon: React.FC<{ className?: string; onClick?: () => void }> = ({
  className,
  onClick,
}) => (
  <svg
    className={className}
    onClick={onClick}
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3768 5.24506C15.9905 5.24506 16.4879 5.74252 16.4879 6.35617C16.4879 6.96982 15.9905 7.46728 15.3768 7.46728H6.87285C6.14461 7.46728 5.55425 8.05764 5.55425 8.78588V25.7938C5.55425 26.5221 6.14461 27.1124 6.87285 27.1124H23.8808C24.609 27.1124 25.1994 26.5221 25.1994 25.7938V17.2898C25.1994 16.6762 25.6968 16.1787 26.3105 16.1787C26.9241 16.1787 27.4216 16.6762 27.4216 17.2898V25.7938C27.4216 27.7494 25.8363 29.3346 23.8808 29.3346H6.87285C4.91731 29.3346 3.33203 27.7494 3.33203 25.7938V8.78588C3.33203 6.83034 4.91731 5.24506 6.87285 5.24506H15.3768ZM27.3471 7.39278C27.9196 6.82028 27.9196 5.89207 27.3471 5.31957C26.7746 4.74707 25.8464 4.74707 25.2739 5.31957L13.9504 16.6431L13.2593 19.4073L16.0236 18.7163L27.3471 7.39278ZM28.9184 3.74822C30.3588 5.18855 30.3588 7.52379 28.9184 8.96413L17.3773 20.5052C17.2349 20.6476 17.0565 20.7486 16.8612 20.7975L12.0017 22.0123C11.188 22.2158 10.4509 21.4787 10.6543 20.6649L11.8692 15.8055C11.918 15.6101 12.019 15.4317 12.1614 15.2893L23.7025 3.74822C25.1429 2.30789 27.4781 2.30789 28.9184 3.74822Z"
      fill="currentColor"
    />
  </svg>
);

export default EditIcon;
